function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M142.18,183.54v-41.36H241V38.19c-14.12-11.59-32.17-18.55-51.81-18.55c-40.32,0-73.92,29.31-80.61,67.74 c-3.75-0.61-7.56-0.92-11.37-0.92c-39.06,0-70.84,31.77-70.84,70.83c0,10.97,2.56,21.73,7.37,31.44C12.6,204.77,0,229.7,0,256.99 c0,28.52,14.39,55.12,37.55,70.95c-1.74,6.85-2.62,13.9-2.62,21.08c0,44,33.27,80.36,75.97,85.27 c10.29,33.85,41.98,58.07,78.29,58.07c19.64,0,37.69-6.96,51.81-18.55V369.82h-98.82v-41.36h-24.67v-30h24.67V271h-24.67v-30 h24.67v-27.46h-24.67v-30H142.18z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M271,229.33 256,229.33 241,229.33 229.33,229.33 229.33,282.67 241,282.67 256,282.67 271,282.67 282.67,282.67  282.67,229.33  "
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M271,172.18h-15h-15h-68.82v167.64H241h15h15h68.82V172.18H271z M312.67,312.67H271h-15h-15h-41.67V199.33H241h15h15 h41.67V312.67z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M512,256.99c0-27.29-12.6-52.22-33.74-68.26c4.81-9.71,7.37-20.47,7.37-31.44c0-39.06-31.78-70.83-70.84-70.83 c-3.81,0-7.62,0.31-11.37,0.92c-6.69-38.43-40.29-67.74-80.61-67.74c-19.64,0-37.69,6.96-51.81,18.55v103.99h98.82v41.36h24.67v30 h-24.67V241h24.67v30h-24.67v27.46h24.67v30h-24.67v41.36H271v103.99c14.12,11.59,32.17,18.55,51.81,18.55 c36.31,0,68-24.22,78.29-58.07c42.7-4.91,75.97-41.27,75.97-85.27c0-7.18-0.88-14.23-2.62-21.08 C497.61,312.11,512,285.51,512,256.99z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var SvgMachineLearning = function SvgMachineLearning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMachineLearning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/machine-learning.12c432c1.svg";
export { ForwardRef as ReactComponent };